import React from "react"
import { actionKeys } from "@love-irish/i18n"
import { IconBook } from "@tabler/icons-react"
import AdventureStoryPreview from "@love-irish/adventure-story-preview"
import BaseListItem from "../base"
import grugHoldingHand from "images/love_irish/adventure/grug-hand-holding.png"

export const Template = ({ item, className, footer }) => (
  <BaseListItem
    item={item}
    className={className}
    footer={footer}
    typeIcon={IconBook}
    typeLabel="Book"
    testId="book-list-item"
    readMore={{ useI18n: true, actionKey: actionKeys.READ }}
    media={
      (item.imageUrl || item.thumbnailUrl) && (
        <div className="pb-12">
          <div className="relative shrink-0">
            <AdventureStoryPreview
              title={
                <a href={item.path}>
                  <img loading="lazy"
                    src={item.thumbnailUrl || item.imageUrl}
                    alt={item.name}
                    className="max-w-[150px]"
                  />
                </a>
              }
              className="bg-secondary-100 p-0 relative h-auto border-0 min-h-fit!"
            />
            <div className="absolute top-full left-1/2 -translate-x-1/2 -translate-y-[46px] w-[80px]">
              <img loading="lazy"
                src={grugHoldingHand}
                className="w-full inline-block"
                alt=""
              />
            </div>
          </div>
        </div>
      )
    }
  />
)

export default Template
